export default {
  nav: {
    home: '首頁',
    features: '功能',
    pricing: '定價',
    faq: 'FAQ',
    translate: '漫畫翻譯',
    startBtn: '開始翻譯',
    vip: 'VIP通道',
    login: '登入',
    logout: '登出',
    lang: '繁體中文',
  },
  landing: {
    title: 'KokeManga 智慧漫畫翻譯工具',
    subtitle: 'AI驅動 · 批次處理 · 原圖渲染',
    desc: '免費線上漫畫翻譯工具，支援JPG、PNG、WEBP等格式',
    hero: {
      badge: 'AI 驅動的漫畫翻譯',
      title: '智慧漫畫翻譯',
      gradientText: '一鍵搞定',
      desc: '批次上傳 · AI 智慧識別 · 原圖渲染 · 多語言翻譯',
      startBtn: '開始翻譯',
      learnMore: '瞭解更多',
      statsTranslated: '累計翻譯',
      statsFree: '免費額度',
      statsFreeNum: '20張/天',
      statsAccuracy: '識別準確率',
    },
    comparison: {
      afterLabel: '翻譯後',
      beforeLabel: '原圖',
    },
    advantage: {
      tag: '為什麼選擇我們',
      title: '強大的翻譯能力',
      desc: '專為漫畫翻譯打造的 AI 工具，讓翻譯變得簡單高效',
      items: [
        {
          title: 'AI 智慧翻譯',
          desc: '每張圖片均採用 <span class="highlight">大模型翻譯，杜絕傳統機翻</span>，智慧識別文字並保持原始排版風格',
        },
        {
          title: '原圖渲染',
          desc: '智慧識別漫畫風格與背景，對翻譯文字進行虛化、修復，完美融入原圖風格',
        },
        {
          title: '批次處理',
          desc: '支援批次上傳多張漫畫圖片，一鍵翻譯整個章節，大幅提升工作效率',
        },
        {
          title: '多語言支援',
          desc: '支援中文、繁體中文、英文翻譯，後續會出臺更多語言',
        },
        {
          title: '隱私安全',
          desc: '全程資料黑箱操作，翻譯完成後 <span class="highlight">24 小時無痕清除</span>，不保留任何上傳與翻譯資料',
        },
        {
          title: '多格式匯出',
          desc: '支援 JPG、PNG、WEBP 等多種格式下載，滿足不同平臺需求',
        },
      ],
    },
    pricing: {
      tag: '算力套餐',
      title: '靈活的定價',
      desc: '獲取算力，解鎖VIP通道，享受快速翻譯、大圖翻譯等VIP功能。算力永久有效不過期',
      unit: '算力',
      note: '購買的算力永久有效，不過期。VIP通道按次消耗算力，具體消耗量根據圖片解析度計算。',
      packages: [
        { amount: '300 算力', price: '¥6', desc: '約可翻譯240-300張漫畫' },
        { amount: '600 算力', price: '¥12', desc: '約可翻譯480-600張漫畫' },
        { amount: '3000+1000 算力', price: '¥60', desc: '約可翻譯3200-4000張漫畫', badge: '+33%' },
        { amount: '6000+3000 算力', price: '¥120', desc: '約可翻譯7200-9000張漫畫', badge: '+50%' },
      ],
    },
    channelCompare: {
      title: '通道對比',
      free: {
        title: '公共佇列（免費）',
        desc: '適合不著急的使用者，排隊等待翻譯',
        items: ['無需登入', '完全免費，不消耗算力', '佇列優先順序低', '每日翻譯數量限制', '不支援大圖翻譯（最大2000×2000）'],
      },
      vip: {
        title: 'VIP通道（消耗算力）',
        desc: '快速翻譯，支援大圖，按次消耗算力',
        items: ['需要登入（免費功能全部權益）', '更多翻譯設定', '快速佇列，優先翻譯', '無次數限制，按次數消耗算力', '支援大圖翻譯（最大2000×20000）'],
      },
    },
    faq: {
      tag: '常見問題',
      title: 'FAQ',
      desc: '如有其他問題，請聯繫我們',
      items: [
        { q: '公共佇列（免費）能翻譯多少張？', a: '我們支援每天免登入翻譯 20 張，翻譯品質與 VIP 佇列一致。' },
        { q: '為啥翻譯的時間有點久？', a: '我們採用大模型翻譯以保證品質，平均每張圖片大模型執行需要 7-8 秒。' },
        {
          q: '為啥有的圖片需要更多算力？',
          a: '常規圖片基本都是 1 算力，只有長圖、超高解析度的圖片才會消耗更多算力。我們的 2 算力換算成解析度也是大於 4K 的。',
        },
        { q: '翻譯出現問題，你們會解決嗎？', a: '翻譯出現任何問題，我們都保障到底。如果出現失敗，會返還失敗的算力，保障使用者的所有合法權益。' },
        {
          q: '傳統機翻和大模型翻譯的區別？',
          a: '傳統機翻依賴固定規則和詞庫，翻譯生硬、上下文脫節，經常出現語義錯誤。大模型翻譯基於深度學習，能理解上下文語境，翻譯更自然流暢，尤其擅長處理漫畫中的口語化表達、擬聲詞和文化梗。',
        },
      ],
    },
    cta: {
      title: '準備好了嗎？',
      desc: '開始使用 Koke Manga，體驗智慧漫畫翻譯',
      btn: '立即開始翻譯',
    },
    footer: {
      features: '功能',
      pricing: '定價',
      faq: 'FAQ',
      login: '登入',
    },
    startBtn: '開始翻譯',
  },
  translate: {
    pageTitle: '智慧漫畫翻譯工具',
    pageDesc: '一鍵上傳 · 自動翻譯 · 公共佇列 · 原圖渲染',
    guideArrow: '點選預覽',
    uploadTitle: '批次上傳漫畫',
    previewTitle: '漫畫預覽',
    historyTitle: '翻譯歷史',
    batchDownload: '批次下載',
    downloading: '下載中...',
    clearList: '清空列表',
    previewDialog: '效果預覽',
    confirm: '確定',
    cancel: '取消',
    systemPrompt: '系統提示',
    reLogin: '重新登入',
    httpError: 'HTTP錯誤',
    deleteConfirm: '確定刪除這個檔案嗎？',
    deleteTitle: '提示',
    deleteSuccess: '刪除成功，已清除後端快取',
    deleteFailed: '刪除失敗',
    clearConfirm: '確定清空所有檔案記錄並清除後端快取嗎？此操作不可恢復',
    clearTitle: '警告',
    clearSuccess: '已清空所有記錄並清除後端快取',
    clearFailed: '清空失敗',
    selectFilesFirst: '請先選擇要下載的檔案',
    invalidFiles: '選中的檔案中有 {count} 個檔案沒有有效的ID，無法下載',
    incompleteFiles: '選中的檔案中有 {count} 個檔案尚未完成翻譯，無法下載',
    downloadingWait: '正在下載中，請稍候...',
    batchDownloadStart: '開始批次下載 {count} 個檔案...',
    batchDownloadSuccess: '批次下載成功',
    batchDownloadFailed: '批次下載失敗',
    downloadSuccess: '下載成功',
    downloadFailed: '下載失敗',
    fileNotFound: '檔案不存在或已被刪除',
    serverError: '伺服器內部錯誤',
    networkError: '網路異常，請檢查網路連線後重試',
    noFileFound: '沒有找到對應檔案',
    fileIdMissing: '檔案ID不存在',
    fileNotComplete: '檔案翻譯尚未完成，請等待',
    paramError: '請求引數錯誤，請檢查選擇的檔案',
    privacy: '隱私條款',
    agreement: '使用者協議',
    about: '關於我們',
    batchDownloadFilename: '漫畫翻譯批次下載',
    uploadFirst: '請先上傳圖片',
    uploadFailed: '上傳失敗',
    uploadNetworkError: '網路異常',
    uploadResult: '上傳結果',
    uploadSuccess: '上傳完成！成功 {count} 張',
    joinQueue: '加入翻譯佇列',
    imageCount: '{current}/{total} 張({size})',
    imagePreview: '漫畫預覽',
  },
  manga: {
    navbar: {
      home: '首頁',
      freeQueue: '免費佇列',
      vipQueue: 'VIP佇列',
      loggedIn: '已登入',
      currentTasks: '當前任務',
      currentCredits: '當前算力',
      getCredits: '獲取算力',
      myOrders: '我的訂單',
      myTranslations: '我的翻譯',
      profile: '個人資訊',
      feedback: '留言建議',
      logout: '登出',
      user: '使用者',
      taskCount: '{count}個',
    },
    footer: {
      privacy: '隱私條款',
      agreement: '使用者協議',
      about: '關於我們',
    },
    queueCard: {
      publicQueue: '公共翻譯佇列：',
      people: '位',
      realtime: '即時更新 · 全員共用',
      speedQueue: 'Speed加速佇列：',
      speedDesc: '每日前100張 · 優先翻譯',
      vipQueue: 'VIP專屬佇列：',
      vipDesc: '快速翻譯 · VIP專享',
    },
    upload: {
      dragHint: '點選或拖拽圖片到此處',
      translating: '翻譯中，請稍候...',
      tip: '最多{max}張，每張不超過 10MB，總大小不超過50MB',
      processing: '正在處理中...',
      onlyImages: '只能上傳圖片檔案!',
      sizeLimit: '圖片大小不能超過10MB!',
      totalSizeLimit: '所有圖片總大小不能超過50MB',
      maxFiles: '最多只能選擇{max}張圖片',
      fileExists: '檔案 {name} 已存在，跳過新增',
      added: '已新增 {name}，當前共 {count} 張圖片',
      removed: '已移除 {name}，剩餘 {count} 張圖片',
      waitTranslate: '正在翻譯中，請等待翻譯完成後再新增圖片',
    },
    fileList: {
      empty: '暫無翻譯記錄',
      selectAll: '全選 ({selected}/{max})',
      timeJustNow: '剛剛',
      timeMinutesAgo: '{count}分鐘前',
      timeHoursAgo: '{count}小時前',
      timeDaysAgo: '{count}天前',
    },
    preview: {
      placeholder: '上傳後即可預覽漫畫',
      clearAll: '清空全部',
      uploading: '上傳中 {progress}%',
      joinQueue: '加入翻譯佇列',
    },
    login: {
      welcomeBack: '歡迎回來',
      createAccount: '建立帳戶',
      loginSubtitle: '登入以使用VIP專屬翻譯通道',
      registerSubtitle: '註冊後即可體驗VIP翻譯服務',
      email: '電子郵件地址',
      password: '密碼',
      confirmPassword: '確認密碼',
      loginBtn: '登 入',
      registerBtn: '註 冊',
      noAccount: '沒有帳戶？點選註冊',
      hasAccount: '已有帳戶？點選登入',
      forgotPassword: '忘記密碼？',
      loginAgreement: '登入即代表已閱讀並同意',
      registerAgreement: '註冊即代表已閱讀並同意',
      and: '與',
      privacyPolicy: '隱私政策',
      channelCompare: '通道對比',
      channelDesc: '瞭解免費通道與VIP通道的區別，VIP通道需消耗算力',
      freeQueue: '公共佇列（免費）',
      freeQueueDesc: '適合不著急的使用者，排隊等待翻譯',
      freeItems: ['無需登入', '完全免費，不消耗算力', '佇列優先順序低', '每日翻譯數量限制', '不支援大圖翻譯（最大2000×2000）'],
      vipQueue: 'VIP通道（消耗算力）',
      vipQueueDesc: '快速翻譯，支援大圖，按次消耗算力',
      vipItems: ['需要登入(免費功能全部權益)', '更多翻譯設定', '快速佇列，優先翻譯', '無次數限制，按次數消耗算力', '支援大圖翻譯（最大2000×20000）'],
      usageTipTitle: '使用建議',
      usageTipDesc: '免費使用者可使用公共佇列免費翻譯，如需快速翻譯或翻譯大圖，可使用VIP通道。購買的算力不過期，可隨時使用。',
      emailRequired: '請輸入電子郵件地址',
      emailInvalid: '請輸入有效的電子郵件地址',
      passwordRequired: '請輸入密碼',
      passwordMin: '密碼長度不能少於6位',
      confirmRequired: '請確認密碼',
      confirmMismatch: '兩次輸入的密碼不一致',
      agreementTitle: '使用者協議',
      privacyTitle: '隱私政策',
      loginSuccess: '登入成功',
      registerSuccess: '註冊成功，請登入',
      loginFailed: '登入失敗，請檢查電子郵件和密碼',
      registerFailed: '註冊失敗，請稍後重試',
    },
    vip: {
      pageTitle: 'VIP專屬翻譯通道',
      pageDesc: 'VIP專享 · 優先處理 · 專屬佇列 · 次數不限',
      uploadTitle: 'VIP專屬上傳',
      previewTitle: 'VIP專屬預覽',
      historyTitle: 'VIP翻譯歷史',
      maxImages: '最多 50 張圖片',
      eachLimit: '每張不超過 10MB',
      totalLimit: '總大小不超過 50MB',
      batchMax: '最大支援批次50張',
      clearHistory: '清空中...',
      clear: '清空',
      searchPlaceholder: '請輸入檔案名稱',
      statusLabel: '翻譯狀態',
      waiting: '等待翻譯',
      translating: '翻譯中',
      failed: '翻譯失敗',
      completed: '已完成',
      query: '查詢',
      reset: '重置',
      fileName: '漫畫名稱',
      translateStatus: '翻譯狀態',
      currentQueue: '當前佇列',
      creditsCost: '消耗算力',
      targetLanguage: '目標語言',
      action: '操作',
      noRecords: '暫無翻譯記錄',
      refresh: '重新整理',
      configTitle: '翻譯配置',
      configLangLabel: '目標翻譯語言',
      configLangPlaceholder: '請選擇翻譯語言',
      configLayoutLabel: '排版模式',
      configLayoutPlaceholder: '請選擇排版模式',
      configConfirm: '確定',
      statusWaiting: '等待翻譯',
      statusTranslating: '翻譯中',
      statusFailed: '翻譯失敗',
      statusCompleted: '已完成',
      statusExpired: '已過期',
      statusUnknown: '未知',
      defaultLang: '簡體中文',
      fileNotFound: '檔案不存在或已被刪除',
      serverError: '伺服器內部錯誤，下載失敗',
      networkError: '網路異常，請檢查網路連線後重試',
      noFileFound: '沒有找到對應檔案',
      fileNotComplete: '檔案翻譯尚未完成，請等待',
      fileIdMissing: '檔案ID不存在，無法預覽',
      selectFilesFirst: '請先選擇要下載的檔案',
      downloadingWait: '正在下載中，請稍候...',
      incompleteFiles: '選中的檔案中有 {count} 個檔案尚未完成翻譯，無法下載',
      batchDownloadStart: '開始VIP批次下載 {count} 個檔案...',
      paramError: '請求引數錯誤，請檢查選擇的檔案',
      deleteConfirm: '確定要刪除這條記錄嗎？',
      deleteTitle: '提示',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗',
      clearConfirm: '確定要清空所有已完成和失敗的翻譯記錄嗎？此操作不可恢復。',
      clearSuccess: '清空成功',
      clearFailed: '清空失敗',
    },
    getPower: {
      title: '漫畫翻譯算力獲取',
      subtitle: '獲取算力，解鎖VIP通道，享受快速翻譯、大圖翻譯等VIP功能。VIP功能無次數限制，按次數消耗算力訂閱。遇到問題',
      contactAdmin: '聯絡站長',
      currentBalance: '當前算力餘額',
      creditsUnit: '算力',
      packageTitle: '算力購買套餐',
      packageDesc: '選擇以下套餐購買算力，算力可用於VIP通道，永久有效不過期',
      noPackage: '暫無可購買的套餐',
      payMethod: '支付方式',
      alipay: '支付寶',
      wechatPay: '微信支付',
      selectPackage: '請選擇套餐',
      buyButton: '立即購買',
      privacyTitle: '隱私保護',
      privacyDesc: '為保障使用者隱私，本系統不儲存任何使用者翻譯的圖片，翻譯完成後24小時內自動清除所有翻譯資料。翻譯完成後，請及時下載。',
      channelCompare: '通道對比',
      channelDesc: '瞭解免費通道與VIP通道的區別，VIP通道需消耗算力',
      usageTipTitle: '使用建議',
      usageTipDesc: '免費使用者可使用公共佇列免費翻譯，如需快速翻譯或翻譯大圖，可使用VIP通道。購買的算力不過期，可隨時使用。',
      calcTitle: '算力計算公式',
      calcDesc: '常規圖片消耗1算力，長圖/超高解析度圖片消耗更多算力。2算力對應解析度大於4K。',
      payPending: '等待支付',
      paySuccess: '支付成功！',
      payFailed: '支付失敗',
      createOrderFailed: '建立支付訂單失敗',
      pleaseSelectPackage: '請先選擇套餐',
      qrcodeTitle: '掃碼支付',
      qrcodeDesc: '請使用{method}掃碼支付',
      payConfirming: '支付確認中...',
      payTimeout: '支付超時，請重試',
    },
    order: {
      loading: '載入中...',
      typeGift: '贈送',
      typeAlipay: '支付寶',
      typeWechat: '微信',
      typeBilibili: 'B站贊助',
      typePaypal: 'PayPal',
      statePending: '待支付',
      stateSuccess: '支付成功',
      stateFailed: '支付失敗',
      stateConfirming: '待確認',
      stateClosed: '已關閉',
      unknown: '未知',
    },
    userMessage: {
      pending: '待處理',
      replied: '已回覆',
      placeholder: '請輸入您想說的話...',
      submitting: '提交中...',
      submit: '提交',
      messageContent: '留言內容',
      suggestionContent: '建議內容',
      message: '留言',
      suggestion: '建議',
    },
    userProfile: {
      nicknamePlaceholder: '請輸入暱稱',
      phoneBound: '已繫結 {phone}',
      phoneUnbound: '未繫結手機',
      emailBound: '已繫結 {email}',
      emailUnbound: '未繫結電子郵件',
      wechatBound: '已授權繫結微信帳號',
      wechatUnbound: '未繫結微信',
      change: '更換',
      bind: '繫結',
      unbind: '解繫結',
      selectImageError: '請選擇圖片檔案',
      imageSizeError: '圖片大小不能超過5MB',
      avatarSuccess: '頭像上傳成功',
      avatarFailed: '上傳失敗',
      avatarRetry: '上傳失敗，請重試',
      saveSuccess: '個人資訊儲存成功',
      saveFailed: '儲存失敗',
      saveRetry: '儲存失敗，請重試',
    },
    resetPassword: {
      title: '重置密碼',
      step1: '驗證電子郵件',
      step2: '輸入驗證碼',
      step3: '設定新密碼',
      emailPlaceholder: '請輸入註冊電子郵件',
      sendCode: '傳送驗證碼',
      codePlaceholder: '請輸入驗證碼',
      newPassword: '新密碼',
      confirmPassword: '確認密碼',
      resetBtn: '重置密碼',
      backToLogin: '返回登入',
      stepDesc1: '請輸入您註冊時使用的電子郵件地址',
      stepDesc2: '請輸入收到的6位驗證碼',
      stepDesc3: '請設定您的新密碼',
      codeSentTo: '驗證碼已傳送至:',
      resendAfter: '{countdown}s 後可重新傳送',
      resendCode: '重新傳送驗證碼',
      verifyBtn: '驗 證',
      codeRequired: '請輸入驗證碼',
      codeLen: '驗證碼為6位數字',
      emailRequired: '請輸入電子郵件地址',
      emailInvalid: '請輸入有效的電子郵件地址',
      passwordRequired: '請輸入密碼',
      passwordMin: '密碼長度不能少於6位',
      confirmRequired: '請確認密碼',
      confirmMismatch: '兩次輸入的密碼不一致',
      codeSentSuccess: '驗證碼已傳送，請查收郵件',
      verifySuccess: '驗證成功，請設定新密碼',
      resetSuccess: '密碼修改成功，請重新登入',
    },
    seo: {
      landing: {
        title: 'KokeManga 智慧漫畫翻譯工具 - AI驅動 · 批次處理 · 原圖渲染',
        description: 'KokeManga是一款免費的線上漫畫翻譯工具，支援多種格式漫畫翻譯，包括JPG、PNG、WEBP等格式，AI智慧翻譯和批次處理。',
      },
      translate: {
        title: 'KokeManga 漫畫翻譯 - 線上漫畫翻譯工具',
        description: '線上漫畫翻譯工具，支援批次上傳、自動翻譯、原圖渲染',
      },
      vip: {
        title: 'KokeManga VIP專屬翻譯通道',
        description: 'VIP專享漫畫翻譯通道，優先處理、專屬佇列、次數不限',
      },
    },
    privacy: {
      intro: '歡迎使用我們的線上漫畫翻譯工具。我們高度重視您的隱私和資料安全。本隱私條款旨在清晰說明我們如何收集、使用、儲存和處理您的資訊，特別是您上傳的漫畫圖片。',
      s1Title: '1. 資訊的收集',
      s1Content: '我們僅收集和訪問您在使用本工具時主動選擇並上傳的漫畫圖片檔案。除此之外，我們不主動收集、儲存或請求您的任何其他個人身份資訊（如姓名、電子郵件、IP地址、裝置資訊等）。',
      s2Title: '2. 資訊的使用方式',
      s2Content: '您上傳的漫畫圖片僅用於提供您所要求的即時翻譯服務。核心的影像處理、文字識別與翻譯計算均在您的本地瀏覽器或裝置中進行。我們承諾：',
      s2Item1: '本地處理：上傳的圖片檔案不會被自動、主動或常規性地傳輸至我們的伺服器或任何第三方伺服器進行處理。',
      s2Item2: '目的限定：圖片內容僅用於生成翻譯結果，不會被用於任何其他目的，包括但不限於機器學習模型訓練、內容分析、營銷或任何形式的再分發。',
      s3Title: '3. 資訊的儲存與保留',
      s3Content: '我們深知臨時檔案的安全性。我們的資料儲存原則如下：',
      s3Item1: '自動清除：所有您上傳的原始圖片檔案及生成的翻譯結果，將在處理完成後的24小時內，從我們的系統內被永久且不可恢復地刪除。',
      s3Item2: '無長期存檔：我們不設立、也不保留任何與您上傳內容相關的長期資料庫、檔案或備份。',
      s4Title: '4. 您的權利',
      s4Content: '作為資料的提供者，您擁有以下權利：',
      s4Item1: '控制權：您完全控制所上傳的內容。您可以在使用後隨時關閉瀏覽器標籤頁。',
      s4Item2: '知情權：您有權透過本條款瞭解我們如何處理您的檔案。',
      s5Title: '5. 第三方服務',
      s5Content: '當前服務不涉及嵌入第三方分析、廣告或跟蹤工具。如果未來引入任何可信的第三方服務以改善功能，我們將在本條款中明確說明，並確保其符合同等嚴格的隱私標準。',
      s6Title: '6. 隱私條款的變更',
      s6Content: '我們可能不時更新本隱私條款。如有重大變更，我們將在工具介面發布顯著通知。您繼續使用我們的服務即表示接受更新後的條款。',
      s7Title: '7. 聯絡我們',
      s7Content: '如果您對本隱私條款或我們的資料處理實踐有任何疑問、意見或顧慮，請透過以下方式聯絡我們：Koke7359@163.com',
      s8Title: '8. 適用法律',
      s8Content: '本隱私條款的訂立、執行和解釋均適用於中華人民共和國法律',
    },
    agreement: {
      updateDate: '最後更新日期：2026年4月2日',
      intro: '歡迎使用本線上漫畫翻譯工具（以下簡稱"本工具"或"本服務"）。請您在使用前仔細閱讀並理解本《使用者協議》（以下簡稱"本協議"）的全部內容。如果您不同意本協議的任何條款，請立即停止使用本工具。您的上傳、訪問或使用行為即視為您已閱讀、理解並同意完全接受本協議及我們的《隱私條款》的約束。',
      s1Title: '1. 服務描述',
      s1Content: '本工具為您提供一項免費的線上技術翻譯服務：您上傳包含文字的漫畫圖片，我們將透過技術手段（如影象識別、機器翻譯）為您生成翻譯結果。您理解並同意，翻譯結果由演演算法自動生成，僅為輔助理解之用，其準確性、完整性、適用性不作任何明示或默示的保證。',
      s2Title: '2. 使用者行為規範',
      s2Content: '您承諾遵守所有適用的法律法規，並獨立承擔因使用本服務所產生的全部責任。您在使用本服務時，不得從事以下行為：',
      s2Subtitle1: '上傳、傳輸、分享或儲存任何含有以下內容或與之相關的漫畫圖片：',
      s2Item1: '侵權內容：侵犯他人智慧財產權（如著作權、商標權）、肖像權、隱私權或其他合法權益的內容。',
      s2Item2: '違法與違規內容：違反任何法律、法規、規章、條例的內容，或包含任何非法、欺詐、誹謗、騷擾、恐嚇性的資訊。',
      s2Item3: '有害與不良內容：包含色情、淫穢、暴力、血腥、仇恨言論，或宣揚種族、性別、宗教、殘疾、性取向等歧視的內容。',
      s2Item4: '敏感內容：涉及國家祕密、國家安全、公共安全、政治敏感及未成年人不適宜的內容。',
      s2Subtitle2: '其他禁止行為：',
      s2Item5: '將本工具用於任何商業目的、非法目的，或進行任何干擾、破壞服務正常執行的行為（如嘗試入侵系統、上傳惡意軟體等）。',
      s2Item6: '冒充任何個人或實體，或虛假陳述您與任何個人或實體的關聯。',
      s3Title: '3. 使用者上傳內容的責任',
      s3Content1: '您應對您上傳的全部漫畫圖片內容（以下簡稱"使用者內容"）承擔全部法律責任。您保證，您擁有上傳該等內容所需的一切合法權利或已獲得充分授權，且該等內容的使用不違反任何法律或侵犯任何第三方權益。',
      s3Content2: '一旦您上傳的內容違反本協議，相關法律責任由您自行承擔，如因此給我們或任何第三方造成損失的，您應負責全額賠償。',
      s4Title: '4. 智慧財產權',
      s4Content1: '您的權利：您保留對您上傳的原始漫畫圖片所擁有的所有智慧財產權及相關權利。您上傳行為本身，不意味著您將任何權利轉讓給我們。',
      s4Content2: '我們的權利：本工具及其提供的服務（包括但不限於軟體、介面、logo、技術）所包含的一切智慧財產權和相關權利，均歸我們及/或許可方所有。未經我們明確書面許可，您不得以任何形式複製、修改、反向工程或進行商業性使用。',
      s5Title: '5. 服務的變更、中斷與終止',
      s5Content1: '我們保留隨時修改、暫停或中斷本服務（或其中任何部分）的權利，且無需事先通知您，也無需對您或任何第三方承擔任何責任。',
      s5Content2: '如果我們有合理理由認為您違反了本協議的任何規定，我們有權單方面立即暫停或終止向您提供服務，並刪除相關使用者內容，而無需承擔任何責任。',
      s6Title: '6. 免責宣告',
      s6Content: '在適用法律允許的最大範圍內，本服務按"現狀"和"可用"提供，我們不提供任何形式的明示或默示保證。您理解並同意：',
      s6Item1: '我們不保證服務不中斷、及時、安全或無錯誤。',
      s6Item2: '我們不保證翻譯結果的準確性、可靠性或適用性。翻譯結果僅供參考，不構成專業翻譯建議，您應自行判斷其價值並對使用結果負責。',
      s6Item3: '我們對因您上傳的內容導致的任何直接、間接、附帶、懲罰性或後果性的損失（包括但不限於資料丟失、利潤損失、商譽損失）不承擔責任，無論我們是否已被告知可能發生此類損害。',
      s7Title: '7. 資料保留',
      s7Content: '您確認並同意，我們依據《隱私條款》對您上傳的圖片及生成的翻譯結果進行臨時處理。所有資料將在處理完成後24小時內自動清除。您有責任自行備份您希望保留的任何內容。',
      s8Title: '8. 協議的修改',
      s8Content: '我們有權隨時更新或修改本協議。更新後的協議將在本頁面公佈，並更新"最後更新日期"。您繼續使用本服務即表示接受更新後的協議。建議您定期查閱本頁面以瞭解最新條款。',
      s9Title: '9. 其他規定',
      s9Item1: '可分性：如果本協議的任何條款被認定為無效或不可執行，該條款應在最小必要範圍內進行限制或排除，其他條款的效力不受影響。',
      s9Item2: '完整協議：本協議與我們的《隱私條款》共同構成您與我們之間關於本服務的完整協議，並取代任何先前的口頭或書面協議。',
    },
    about: {
      title: '歡迎來到 Koke',
      intro: '我們始於一個簡單的信念：語言不應成為探索精彩漫畫世界的屏障。',
      missionTitle: '我們的使命',
      missionContent: 'Koke 致力於打造一款真正高效、簡潔且免費的智慧翻譯工具，讓每一位漫畫愛好者都能無障礙地享受閱讀的樂趣。我們相信，科技應當服務於人，以最無感的方式消除障礙，讓精彩的故事和藝術直達人心。',
      coreTitle: '我們的核心：您的隱私與便捷',
      toolTitle: '純粹的工具',
      toolContent: 'Koke 是一款功能聚焦的工具。您上傳，我們翻譯，如此而已。我們不做社群，不儲存內容，不追蹤使用者。',
      privacyTitle: '隱私至上',
      privacyContent: '您的資料只為您服務。為最大限度保護您的隱私，翻譯所需的影像處理與識別均在您的本地瀏覽器中完成，我們不會將您的原始圖片傳輸至伺服器。所有相關資料將在24小時後自動徹底清除，我們不留存任何副本。這是我們對您信任的承諾。',
      efficientTitle: '簡潔高效',
      efficientContent: '我們摒棄一切不必要的功能與複雜的介面，專注於提升從上傳到獲得翻譯結果的整體速度與體驗，讓翻譯如翻頁般自然流暢。',
      futureTitle: '展望未來',
      futureContent: '我們將持續最佳化翻譯的準確性與對複雜版式的處理能力，並嚴格恪守"高效、簡潔、免費、安全"的初心。我們希望 Koke 能成為您探索漫畫宇宙時，手中那把輕巧而可靠的鑰匙。',
      thankYou: '感謝您的使用。',
      signature: 'Koke 團隊 敬上',
    },
  },
}
